import * as React from "react"
import { AdminSidebar } from "@/components/AdminSidebar"
import { cn } from "@/lib/utils"

// Admin area chrome: the black AdminSidebar rail on the left, content to its
// right. The left padding matches the rail's width from lg up, where the rail is
// fixed and permanent; below that the rail is an off-canvas drawer that overlays
// rather than displaces, so the content sits at full width and the drawer's own
// slim bar provides the opener.
export function AdminShell({
  children,
  wide = false,
}: {
  children: React.ReactNode
  wide?: boolean
}) {
  return (
    <div className="min-h-screen bg-page text-ink-body">
      <AdminSidebar />
      <div className="lg:pl-56">
        <main className="px-6 py-8 sm:px-10">
          <div className={cn("mx-auto", wide ? "max-w-6xl" : "max-w-4xl")}>
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}
